export * from "@fortawesome/pro-duotone-svg-icons";
